import React from 'react'

export interface MusicDescriptionProps {
  /** 是否换行省略，默认 true */
  lineClamp?: boolean
  className?: string
  children?: string | null | React.ReactNode
}

const MusicDescription: React.FC<MusicDescriptionProps> = (props) => {
  const { lineClamp = true, className, children } = props

  if (!children) {
    return null
  }

  if (lineClamp) {
    return (
      <div
        className={cls`text-f-text-quaternary line-clamp-1 text-sm ${className}`}
      >
        {children}
      </div>
    )
  }

  return (
    <div
      className={cls`text-f-text-quaternary whitespace-break-spaces break-words text-sm ${className}`}
    >
      {children}
    </div>
  )
}

export default MusicDescription
